import { useEffect, useState } from "react";
import SubsPromoCarousel from "../items/SubsPromoCarousel";
import img from "../../assets/images/logo/logo.png";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
const promoSlides = [
  {
    title: "أحصل على الموقع الجغرافي",
    description: "يمكنك معرفة موقع تواجد أي عضو من الأعضاء",
    img: img,
  },
  {
    title: "تغيير اسم المستخدم",
    description:
      "يمكنك تغيير اسم المستخدم الخاص بك والذي يظهر عند باقي الأعضاء",
    img: img,
  },
  {
    title: "التحكم بحالة اتصالك",
    description: "يمكنك تغيير حالة اتصالك بسهولة",
    img: img,
  },
  {
    title: "تغيير رسالة المستخدم ",
    description: "غير تفضيلاتك البلد المفضل الجنسية المفضلة",
    img: img,
  },
];
const FloatingSubAd = () => {
  const [visible, setVisible] = useState(false);

  const initialDelay = 5000; // 5s after page load
  const displayDuration = 14000; // visible for 10s
  const repeatInterval = 900000; // repeat every 60s

  useEffect(() => {
    let showTimeout, hideTimeout, repeatIntervalId;

    // function to show then hide after duration
    const showAd = () => {
      setVisible(true);
      hideTimeout = setTimeout(() => setVisible(false), displayDuration);
    };

    // show first time
    showTimeout = setTimeout(() => {
      showAd();

      // setup interval after first appearance
      repeatIntervalId = setInterval(() => {
        showAd();
      }, repeatInterval);
    }, initialDelay);

    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      clearInterval(repeatIntervalId);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
       zIndex:10000
      }}
    >
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{
          width: "300px",
          height: "400px",
          zIndex: 9999,
          background: "#210053",
           padding: "10px",
        }}
      >
        <SubsPromoCarousel
          promoSlides={promoSlides}
          interval={4000}
          showClose
          onClose={() => setVisible(false)}
        />
        <Link to="/subscriptions">
          <button className="btn btn-outlined btn-warning" onClick={()=>setVisible(false)}>معرفة المزيد</button>
        </Link>
      </div>
    </div>
  );
};

export default FloatingSubAd;
